import { it, type TranslationDictionary } from './it';
import { en } from './en';

export type Locale = 'it' | 'en' | 'fr' | 'pt' | 'es' | 'ru' | 'zh' | 'ar';

export const SUPPORTED_LOCALES: readonly Locale[] = ['it', 'en', 'fr', 'pt', 'es', 'ru', 'zh', 'ar'] as const;
export const DEFAULT_LOCALE: Locale = 'it';
export const RTL_LOCALES: readonly Locale[] = ['ar'] as const;

/** Flatten a nested object type into dot-notation keys */
type FlattenKeys<T, Prefix extends string = ''> = T extends Record<string, unknown>
  ? {
      [K in keyof T & string]: T[K] extends Record<string, unknown>
        ? FlattenKeys<T[K], `${Prefix}${K}.`>
        : `${Prefix}${K}`;
    }[keyof T & string]
  : never;

export type TranslationKey = FlattenKeys<TranslationDictionary>;

/**
 * Returns the translation dictionary for the given locale.
 */
export function getTranslations(locale: Locale): TranslationDictionary {
  switch (locale) {
    case 'en': return en;
    default: return it;
  }
}

/**
 * Check if a locale uses right-to-left text direction.
 */
export function isRtl(locale: Locale): boolean {
  return (RTL_LOCALES as readonly string[]).includes(locale);
}

export type { TranslationDictionary };
